module.exports = __webpack_public_path__ + "img/lushiAppImage.02ac860a.png";